import { render, staticRenderFns } from "./CorpBar.vue?vue&type=template&id=10c3b6fe&scoped=true&"
var script = {}
import style0 from "./CorpBar.vue?vue&type=style&index=0&id=10c3b6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3b6fe",
  null
  
)

export default component.exports